import { ComponentFactoryResolver, Directive, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ButtonComponent } from '../simple-button/button.component';
import { CheckboxComponent } from '../simple-checkbox/checkbox.component';
import { DateComponent } from '../simple-date/date.component';
import { FileUploadComponent } from '../simple-file-upload/file-upload.component';
import { PriceComponent } from '../simple-price/price.component';
import { RadiobuttonComponent } from '../simple-radiobutton/radiobutton.component';
import { SelectComponent } from '../simple-select/select.component';
import { SimpleFieldConfig } from '../simple-field.interface';
import { InputLeadComponent } from '../simple-input/input-lead/input-lead.component';


const componentMapper = {
  text: InputLeadComponent,
  button: ButtonComponent,
  select: SelectComponent,
  date: DateComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  price:PriceComponent,
  file:FileUploadComponent,
};
@Directive({
  selector: "[dynamicField]"
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: SimpleFieldConfig;
  @Input() group: UntypedFormGroup;

  @Input() type: any=1;

  @Input() formType: any='outline';
  
@Output() valueChange = new EventEmitter();
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.inputType]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    this.componentRef.instance.type = this.type;
    this.componentRef.instance.formType = this.formType;

   
    if(this.type==2){
      this.group.valueChanges.subscribe(values => {
        console.log(values);
        this.valueChange.emit(this.group.value)
      });
      this.valueChange.emit(this.group.value);
    }
    
  }
}
